type EndpointPath = {
    path?: string;
    version?: string;
};

type EndpointOverrideConfig = Record<string, EndpointPath>;

type EndpointOverrides = Record<string, Record<string, EndpointOverrideConfig>>;

const endpointOverridesConfig: EndpointOverrides = {};

export const getEndpointOverrideTests = (config: EndpointOverrides) => {
    const testNames: string[] = [];
    (Object.keys(config) as Array<keyof typeof config>).map((endpoint) => {
        Object.keys(config[endpoint]).map((test) => {
            testNames.push(test);
        });
    });
    return testNames;
};

const endpointOverrideTests = getEndpointOverrideTests(endpointOverridesConfig);

export { endpointOverridesConfig, endpointOverrideTests };
